<template>
    <VStatusScreen
        tone="warning"
        :title="$t('payment_error.title')"
        :message="$t('payment_error.payment_taken')">
        <template #icon>
            <svg viewBox="0 0 24 24" fill="none">
                <path d="M10.3 3.9 2.5 18a2 2 0 0 0 1.7 3h15.6a2 2 0 0 0 1.7-3L13.7 3.9a2 2 0 0 0-3.4 0Z"
                      stroke="currentColor" stroke-width="2" stroke-linejoin="round" />
                <path d="M12 9v4" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
                <circle cx="12" cy="16.5" r="1.2" fill="currentColor" />
            </svg>
        </template>

        <template #body>
            <div class="pay-error-card">
                <div class="pay-error-card__when">
                    <span class="pay-error-card__label">{{ $t('payment_error.event_datetime') }}</span>
                    <span class="pay-error-card__value">{{ formattedTimestamp }}</span>
                </div>
                <p class="pay-error-card__note">{{ $t('payment_error.contact_staff') }}</p>
                <p class="pay-error-card__apology">{{ $t('payment_error.apology') }}</p>
            </div>
        </template>
    </VStatusScreen>
</template>

<script>
import VStatusScreen from "@/components/ui/VStatusScreen.vue";

const stamp = () => new Date().toLocaleString('pl-PL', {
    year: 'numeric', month: '2-digit', day: '2-digit',
    hour: '2-digit', minute: '2-digit', second: '2-digit',
});

export default {
    name: "VPaymentError",
    components: { VStatusScreen },
    props: {
        timestamp: { type: String, default: stamp },
    },
    computed: {
        formattedTimestamp() {
            return this.timestamp || stamp();
        },
    },
};
</script>

<style lang="scss" scoped>
.pay-error-card {
    text-align: left;
    padding: 18px;
    border: 1px solid var(--border-subtle);
    border-radius: var(--radius-2xl);
    background: var(--surface-card);
    box-shadow: var(--shadow-sm);
}

.pay-error-card__when {
    display: flex;
    flex-direction: column;
    gap: 3px;

    padding: 12px 14px;
    margin-bottom: 14px;

    border-radius: var(--radius-lg);
    background: var(--warning-soft);
}

.pay-error-card__label {
    font-size: 12px;
    font-weight: var(--weight-bold);
    letter-spacing: 0.04em;
    text-transform: uppercase;
    color: var(--warning);
}

.pay-error-card__value {
    font-size: var(--text-md);
    font-weight: var(--weight-bold);
    color: var(--text-primary);
}

.pay-error-card__note,
.pay-error-card__apology {
    margin: 0;
    font-size: 13.5px;
    line-height: 1.5;
    color: var(--text-secondary);
}

.pay-error-card__apology {
    margin-top: 12px;
    font-weight: var(--weight-semibold);
    color: var(--text-primary);
}
</style>
